export default {
  data () {
    return {
      inputWith: 12,

      formRules: {
        batchids: [
          {required: true, message: '批次编号不能为空', trigger: 'blur'},
        ],
        name: [
          {required: true, message: '任务包名称不能为空', trigger: 'blur'},
        ],
        type: [
          {required: true, message: '任务类型不能为空', trigger: 'blur'},
        ],
        priority: [
          {required: true, message: '优先级不能为空', trigger: 'blur'},
          {validator: this.positiveIntegerValidator, trigger: 'blur'},
        ],
        starttime: [
          {required: true, message: '上架时间不能为空', trigger: 'blur'},
        ],
        endtime: [
          {required: true, message: '下架时间不能为空', trigger: 'blur'},
          {validator: this.endtimeValidator, trigger: 'blur'},
        ],
      },

      dataModel: {
        customerid: '',
        projectid: '',
        batchids: [],
        name: '',
        type: 0,
        priority: 1,
        starttime: '',
        endtime: '',
        memo: ''
      },

      optionModel: {
        customers: [],
        projects: [],
        batches: [],
        taskTypes: [],
      },

      inLoading: {
        customerid: false,
        projectid: false,
        batchids: false,
      },
    }
  },



  created () {
    let reqApis = [request('getHomeTaskPackageTypeOptions')]

    if (this.$route.params.packageId) { // 修改
      reqApis.push(request('getHomeTaskPackageDetail', this.$route.params.packageId))
    }

    request.all.page(reqApis).then(([optionData, editData]) => {
      this.optionModel.taskTypes = optionData.data.taskType

      if (!editData) return
      filter.setLoop(this.dataModel, editData.data)
    })
  },



  methods: {
    ...request.map(['getBatchTable', 'getBatchDetail']),
    // 搜索客户编号
    onSearchCustomers (val = '') {
      if (val) {
        this.inLoading.customerid = true

        request.alert('searchPriceBatchItems', {
          type: 1,
          keyword: val,
        }).then(({data}) => {
          this.inLoading.customerid = false
          this.optionModel.customers = data.data
        }).catch(() => {
          this.inLoading.customerid = false
        })
      } else {
        this.optionModel.customers = []
      }
    },

    onChangeCustomerId () {
      this.optionModel.customers = ''
      this.dataModel.projectid = ''
      this.dataModel.batchids = []
    },

    onChangeCustomerVisible (isShow) {
      if (isShow) return
      this.optionModel.customers = []
    },


    // 搜索项目编号
    onSearchProjects (val = '') {
      if (val) {
        this.inLoading.projectid = true

        request.alert('searchPriceBatchItems', {
          type: 2,
          keyword: val,
          parent_id: this.dataModel.customerid,
        }).then(({data}) => {
          this.inLoading.projectid = false
          this.optionModel.projects = data.data
        }).catch(() => {
          this.inLoading.projectid = false
        })
      } else {
        this.optionModel.projects = []
      }
    },

    onChangeProjectId () {
      this.dataModel.batchids = []
    },

    onChangeProjectVisible (isShow) {
      if (isShow) return
      this.optionModel.projects = []
    },


    // 搜索批次编号
    onSearchBatches (val = '') {
      if (val) {
        this.inLoading.batchids = true

        request.alert('searchPriceBatchItems', {
          type: 3,
          keyword: val,
          parent_id: this.dataModel.projectid,
        }).then(({data}) => {
          this.inLoading.batchids = false
          this.optionModel.batches = data.data
        }).catch(() => {
          this.inLoading.batchids = false
        })
      } else {
        this.optionModel.batches = []
      }
    },

    onChangeBatchVisible (isShow) {
      if (isShow) return
      this.optionModel.batches = []
    },


    // 验证正整数输入
    positiveIntegerValidator (rule, value, callback) {
      if (!Number.isInteger(value)) {
        callback(new Error('请输入正整数'))
      } else {
        callback()
      }
    },


    // 验证下架时间
    endtimeValidator (rule, value, callback) {
      if (Date.parse(this.dataModel.endtime) <= Date.parse(this.dataModel.starttime)) {
        callback(new Error('下架时间必须晚于上架时间'))
      } else {
        callback()
      }
    },


    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          this.$message.error('提交内容填写不正确！')
          return
        }

        const submitApi = this.$route.params.packageId ? 'updateHomeTaskPackage' : 'createHomeTaskPackage'

        const submitModel = {
          ...this.dataModel,
        }

        if (this.$route.params.packageId) {
          submitModel.id = this.$route.params.packageId
        }

        request.common(submitApi, submitModel).then((res) => {
          this.$router.push({name: '首页任务包设置'})
        })
      })
    },
    unionBy: _.unionBy,
  },
}



// WEBPACK FOOTER //
// ./src/views/task-package-home/pages/TaskPackageHomeForm.js